var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegend0507(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.589 14.69V5.45h-1.442v9.24h1.442zm-9.632-1.75c1.484-.56 2.534-1.708 3.108-3.122.546 1.316 1.582 2.352 3.024 2.884l.742-1.148c-1.946-.672-3.052-2.366-3.052-4.158v-1.26h-1.47v1.26a4.647 4.647 0 0 1-3.094 4.382l.742 1.162zm9.996 4.9v-1.176H9.785v-2.842H8.329v4.018h8.624zm13.033-1.274v-1.19H24.96v-2.982h3.738v-1.162h-7.322V7.55h7.21V6.388h-8.652v6.006h3.584v2.982h-4.984v1.19h11.452zm11.31 1.54V5.422H39.84v12.684h1.456zm-9.66-2.576c1.526-.742 2.646-2.24 3.22-4.074.574 1.708 1.68 3.108 3.136 3.794l.84-1.148c-1.988-.896-3.276-3.22-3.276-5.544V6.486h-1.442v2.072c0 2.436-1.316 4.858-3.332 5.768l.854 1.204z",
    stroke: "#484284",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.589 14.69V5.45h-1.442v9.24zM6.957 12.94c1.484-.56 2.534-1.708 3.108-3.122.546 1.316 1.582 2.352 3.024 2.884l.742-1.148c-1.946-.672-3.052-2.366-3.052-4.158v-1.26h-1.47v1.26a4.647 4.647 0 0 1-3.094 4.382l.742 1.162zM16.953 17.84v-1.176H9.785v-2.842H8.329v4.018zM29.986 16.566v-1.19H24.96v-2.982h3.738v-1.162h-7.322V7.55h7.21V6.388h-8.652v6.006h3.584v2.982h-4.984v1.19zM41.296 18.106V5.422H39.84v12.684zM31.636 15.53c1.526-.742 2.646-2.24 3.22-4.074.574 1.708 1.68 3.108 3.136 3.794l.84-1.148c-1.988-.896-3.276-3.22-3.276-5.544V6.486h-1.442v2.072c0 2.436-1.316 4.858-3.332 5.768l.854 1.204z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegend0507);
export default __webpack_public_path__ + "static/media/icon-legend-05-07.928adbff3b9c14c00b9a3f7600da3345.svg";
export { ForwardRef as ReactComponent };